import { combineReducers } from 'redux'
import { createMigrate, MigrationManifest, persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'

import { configureStore } from '@reduxjs/toolkit'

import rootSaga from './rootSaga'
import ui from './ui'
import refinanciamento from './refinanciamento'
import { contratacaoLoadingPersistTransform } from './refinanciamento/contratacao/persistTransform'
import { modalityAccountPersistTransform } from './refinanciamento/dadosPessoais/persistTransform'
import session from './session'
import biometria from './biometria'

const sagaMiddleware = createSagaMiddleware()

const uiMigrations: MigrationManifest = {
  1: (state) => {
    if (!state) return state

    const persistedUi: Record<string, unknown> & typeof state = { ...state }
    delete persistedUi.error
    return persistedUi
  },
}

export const reducers = combineReducers({
  ui: persistReducer(
    {
      key: 'ui',
      storage,
      version: 1,
      blacklist: ['error'],
      migrate: createMigrate(uiMigrations),
    },
    ui,
  ),
  refinanciamento: persistReducer(
    {
      key: 'refinanciamento',
      storage,
      transforms: [modalityAccountPersistTransform, contratacaoLoadingPersistTransform],
    },
    refinanciamento,
  ),
  biometria: persistReducer({ key: 'biometria', storage }, biometria),
  session: persistReducer({ key: 'session', storage }, session),
})

const store = configureStore({
  reducer: reducers,
  middleware: [sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production',
})

const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

export { store, persistor }
